// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Ojsih","label":"styles_label__1bz0o","snowy":"styles_snowy__GhgRH","cloudy":"styles_cloudy__cGh6W"};